module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-MEETUP.025ce277.png";